import { Stack, styled } from "@mui/material";

const StyleStack = styled(Stack)(({ direction, theme }) => ({
  border: `1px solid ${theme.palette.common.border}`,
  borderRadius: theme.shape.borderRadius,
  alignItems: direction === "row" ? "center" : "flex-start",
}));

export default StyleStack;
